import React, { useState } from 'react';

// components
import Form from '../../../components/Form/Form';

const formStyles = {
  service: { display: 'grid', gap: '20px', gridTemplateColumns: `1fr 44px` },
};

const NewDealService = () => {
  const [service, setService] = useState({
    form: [
      [{ type: 'select', label: 'Дополнительная услуга', placeholder: 'Выберите из списка' }, { type: 'delete' }],
    ],
  });

  const handleAddForm = () => {
    setService((prev) => ({
      ...prev,
      form: [...prev.form, prev.form[0]],
    }));
  };

  const handleDeleteForm = (e, formIndex) => {
    e.preventDefault();
    if (service.form.length > 1) {
      const filteredArray = service.form.filter((item, idx) => idx !== formIndex);
      setService((prev) => ({
        ...prev,
        form: filteredArray,
      }));
    }
  };

  return (
    <div style={{ padding: '10px 20px', backgroundColor: 'white', marginTop: '20px', border: '1px solid #E0E0E0' }}>
      {service.form.map((item, index) => (
        <Form
          key={index}
          inputs={service.form[index]}
          title={index === 0 ? 'Дополнительные услуги' : false}
          grid={formStyles.service}
          addFormButton={index === service.form.length - 1 ? 'Добавить еще дополнительную услугу' : false}
          addForm={handleAddForm}
          deleteForm={(e) => handleDeleteForm(e, index)}
        />
      ))}
    </div>
  );
};

export default NewDealService;
